import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    weekday: 'short', 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
}

export function formatTime(timeString) {
  return timeString;
}

/**
 * Compute the end time for a booking's time slot given a start slot
 * (e.g. "10:00-11:00") and duration in hours.
 * Returns "HH:MM" — wraps to 00:00 once the day rolls over.
 */
export function getEndTime(startSlot, duration = 1) {
  if (!startSlot) return '';
  const startTime = String(startSlot).split('-')[0];
  const [hoursRaw, minutesRaw] = startTime.split(':').map(Number);
  if (Number.isNaN(hoursRaw) || Number.isNaN(minutesRaw)) return '';
  let endHour = hoursRaw + Number(duration || 1);
  if (endHour >= 24) endHour -= 24;
  return `${String(endHour).padStart(2, '0')}:${String(minutesRaw).padStart(2, '0')}`;
}

export function getStatusColor(status) {
  const colors = {
    PENDING_ALLOCATION: 'status-pending',
    AWAITING_PAYMENT: 'status-awaiting',
    CONFIRMED: 'status-confirmed',
    CANCELLED: 'status-cancelled',
    RELEASED: 'status-released'
  };
  return colors[status] || 'status-pending';
}

export function getSportColor(sport) {
  return sport === 'badminton' ? 'badge-badminton' : 'badge-pickleball';
}